import React from 'react';

import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal } from '@material-ui/core';

import ButtonsUseStyles from 'consts/styles/Buttons';
import Icons from 'consts/icons';
import ConfirmationReset from './ConfirmationReset';

const SendEmail = props => {
  const { emailValue, language } = props;

  const [confirm, setConfirm] = React.useState(false);

  const classesButtons = ButtonsUseStyles();

  return (
    <>
      <Button
        className={`${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsRectangle}`}
        type="button"
        onClick={() => setConfirm(true)}
      >
        <Icons.Filters.ButtonPublic />
        &nbsp;{language.resetPassword.emailPage.resetPassword_}
      </Button>
      <Modal open={confirm} onClose={() => setConfirm(false)}>
        <>
          <ConfirmationReset emailValue={emailValue} setConfirm={setConfirm} />
        </>
      </Modal>
    </>
  );
};

SendEmail.propTypes = {
  emailValue: PropTypes.string,
  language: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  language: state.language,
});

export default connect(mapStateToProps)(SendEmail);
